import { getScopedTranslate, useScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'formatter';

export const getDescription = (action: JourneyAction<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);
  return action.description ?? t('noDescription');
};

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={t('title')} descriptionText={node.data.description}>
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Formatter',
    noDescription: 'No description',
  },
};
